// login-frontend/src/components/PetSim/ai/qlearn.js
export default class QTable {
    constructor({ actions, alpha = 0.15, gamma = 0.92, epsilon = 0.08 } = {}) {
        this.actions = actions;
        this.alpha = alpha;
        this.gamma = gamma;
        this.epsilon = epsilon;
        this.q = Object.create(null);
    }
    static zeros(n) { return new Float64Array(n).fill(0); }
    _row(key) {
        if (!this.q[key]) this.q[key] = QTable.zeros(this.actions.length);
        return this.q[key];
    }
    act(key) {
        const row = this._row(key);
        if (Math.random() < this.epsilon) return Math.floor(Math.random() * this.actions.length);
        let best = 0, bestV = row[0];
        for (let i = 1; i < row.length; i++) if (row[i] > bestV) { best = i; bestV = row[i]; }
        return best;
    }
    update(s, a, r, s2) {
        const row = this._row(s);
        const qsa = row[a];
        const next = this._row(s2);
        let maxNext = next[0];
        for (let i = 1; i < next.length; i++) if (next[i] > maxNext) maxNext = next[i];
        const target = r + this.gamma * maxNext;
        row[a] = qsa + this.alpha * (target - qsa);
    }
    toJSON() { return { actions: this.actions, alpha: this.alpha, gamma: this.gamma, epsilon: this.epsilon, q: this.q, v: 1 }; }
    static fromJSON(d) {
        const qt = new QTable({ actions: d.actions, alpha: d.alpha, gamma: d.gamma, epsilon: d.epsilon });
        qt.q = d.q || Object.create(null);
        return qt;
    }
}
